import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseResponse } from '@models/common.model';
import { FavoriteLocationModel, SearchLocationRequestModel } from '@models/location.model';
import { HttpService } from '@services/http.service';
import { catchError, map, Observable, of } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class LocationService {
    constructor(private _http: HttpService) {}

    /**
     * Get cheap flight
     *
     * @param {SearchLocationRequestModel}
     * @return {*}  {Observable<FavoriteLocationModel[]>}
     * @memberof LocationService
     */
    public getListFavoriteLocation(
        reqParams: SearchLocationRequestModel
    ): Observable<FavoriteLocationModel[] | []> {
        return this._http
            .get<BaseResponse<FavoriteLocationModel[]>>(
                `Location/SearchListFavoriteLocationManage`,
                {
                    params: new HttpParams({
                        fromObject: {
                            ...reqParams,
                        },
                    }),
                }
            )
            .pipe(
                catchError(() => {
                    return of(new BaseResponse<FavoriteLocationModel[]>({ Data: [] }));
                }),
                map((res) => res.Data || [])
            );
    }
}
